var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#48A49D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 15.8789C11.3166 16.2694 10.6834 16.2694 10.2929 15.8789L8.41397 14C8.0235 13.6096 7.39043 13.6096 6.99997 14C6.6095 14.3905 6.6095 15.0236 6.99997 15.414L10.2929 18.7069C10.6834 19.0974 11.3166 19.0974 11.7071 18.7069L20 10.414C20.3904 10.0236 20.3904 9.39049 20 9.00003C19.6095 8.60956 18.9764 8.60956 18.586 9.00003L11.7071 15.8789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.879afe0fd250c5a434f45332bd4e253d.svg";
export { ForwardRef as ReactComponent };